module.exports = __webpack_public_path__ + "img/usecase_enterprise_04.3cb9659f.jpg";